import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

const document = `
     _id
    code
    name
    status
    remarks
    tags
    date
    dueDate
    shipDate
    poNumber
    grossAmount
    discountAmount
    netAmount
    dueNotice
    url
    billTo {
      _id
      profile {
        name
        email
        picture
      }
      status
      company {
        _id
        name
      }
    }
    items {
      _id
      name
      description
      quantity
      price
      discountPercent
      discountAmount
      amount
      order
      backOrder
    }
    payment {
      total
      balance
      items {
        _id
        date
        amount
        source
        remarks
      }
    }
    timeZone
     `
//endregion

export const queries = buildGraphqlQuery('Invoice', document, ['items'])
export const updateFieldQuery = (fieldName) => buildGraphqlQuery('Invoice', `_id ${fieldName}`)

export const getInvoiceTotalAmount = gql`
  query getInvoiceTotalAmount($filter: JSON!) {
    getInvoiceTotalAmount(filter: $filter)
  }
`

export const invoiceListQuery = gql`
  query getInvoiceList($filter: JSON, $options: JSON) {
    getInvoiceList(filter: $filter, options: $options) {
        _id
      ${document}
    }

    getInvoiceListMeta(filter: $filter) {
      count
    }
  }
`
